import script from "./UiDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiDrawer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__